import { Element } from "./Element";
import { Root } from "./Root";
import { Svg } from "./Svg";

export const Icon = {
    Root: Root,
    Element: Element,
    Svg: Svg,
}